import { render, staticRenderFns } from "./BlobImage.vue?vue&type=template&id=3ecb2d3a"
import script from "./BlobImage.vue?vue&type=script&lang=js"
export * from "./BlobImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports